import { render, staticRenderFns } from "./AsideVideo.vue?vue&type=template&id=3dcaaf4c&scoped=true"
import script from "./AsideVideo.vue?vue&type=script&lang=js"
export * from "./AsideVideo.vue?vue&type=script&lang=js"
import style0 from "./AsideVideo.vue?vue&type=style&index=0&id=3dcaaf4c&prod&scoped=scss&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcaaf4c",
  null
  
)

export default component.exports